import { render, staticRenderFns } from "./DashboardMessen.vue?vue&type=template&id=5a36f88a"
import script from "./DashboardMessen.vue?vue&type=script&lang=js"
export * from "./DashboardMessen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports